import { render, staticRenderFns } from "./AutoImportCountdown.vue?vue&type=template&id=3dbc60a0&scoped=true"
import script from "./AutoImportCountdown.vue?vue&type=script&lang=js"
export * from "./AutoImportCountdown.vue?vue&type=script&lang=js"
import style0 from "./AutoImportCountdown.vue?vue&type=style&index=0&id=3dbc60a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc60a0",
  null
  
)

export default component.exports